import React from "react";
import { Container, Row, Col } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Footer = () => {
  return (
    <footer className='site-footer section border-top'>
      <Container className='pb-3'>
        <Row className='gap-y text-center text-md-left'>
          <Col md='6' lg='6' className='mr-auto'>
            <p className='lead'>
              <span className='bold'>Morph Studios</span> — an extended reality
              &amp; gaming studio.
            </p>
          </Col>

          <Col md='4' lg='4'>
            <h6 className='py-2 bold'>Find us</h6>

            <p>
              Follow along for new titles, drops, and experiences.
            </p>
            <nav className='nav justify-content-center justify-content-md-start'>
              <a
                href='https://www.instagram.com/morphxr/'
                target='_blank'
                rel='noopener noreferrer'
                className='btn btn-circle btn-sm brand-instagram'
              >
                <FontAwesomeIcon icon={["fab", "instagram"]} />
              </a>
              <p> </p>
              <a
                href='https://www.twitter.com/morphxr/'
                target='_blank'
                rel='noopener noreferrer'
                className='btn btn-circle btn-sm brand-twitter'
              >
                <FontAwesomeIcon icon={["fab", "twitter"]} />
              </a>
            </nav>
          </Col>
        </Row>

        <hr className='mt-5' />

        <Row className='small align-items-center'>
          <Col md='4'>
            <p className='mt-2 mb-md-0 text-muted text-center text-md-left'>
              © {new Date().getFullYear()}{" "}
              <a
                href='https://morphxr.io'
                target='_blank'
                rel='noopener noreferrer'
              >
                Qmulo, Inc.
              </a>{" "}
              All Rights Reserved — Morph Studios and its titles are Qmulo,
              Inc. products
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
